<style lang="scss" scoped>
.home {
  padding: 0;
  margin-top: -10px;

  ::v-deep .el-card__body {
    padding-bottom: 10px;
  }
}




.ys_icon{
  font-size:30px;
  color:#dfdfdf;
}
</style>

<template>
  <div class="home">
	
    <!-- <l-auth auth="c_home_show">
      <l-c-home></l-c-home>
    </l-auth>

    <l-auth auth="mt_home_show">
      <l-mt-home ></l-mt-home>
    </l-auth> -->
    <div class="mg_10">
      <h1>数据统计</h1>
    </div>
    <el-row>
      <el-col :span="6">
        <div class="mg_10">
          <div class="ys_box ys_left_border_primary flex justify-between items-center">
          <div>
            <p class="title">器材类别数</p>
            <p>{{place_new_count}}</p>
          </div>
          <i class="el-icon-circle-plus ys_icon"></i>
          </div>
        </div>
      </el-col>
      <el-col :span="6">
        <div class="mg_10">
          <div class="ys_box ys_left_border_success flex justify-between items-center">
          <div>
            <p class="title">消防柜总数</p>
            <p>{{0}}</p>
          </div>
          <i class="el-icon-success ys_icon"></i>
          </div>
        </div>
      </el-col>
      <el-col :span="6">
        <div class="mg_10">
          <div class="ys_box ys_left_border_error flex justify-between items-center">
          <div>
            <p class="title">待检消防柜数量</p>
            <p>{{0}}</p>
          </div>
          <i class="el-icon-warning ys_icon"></i>
          </div>
        </div>
      </el-col>
      
      <el-col :span="6">
        <div class="mg_10">
          <div class="ys_box ys_left_border_info flex justify-between items-center">
          <div>
            <p class="title">有缺损的消防柜数</p>
            <p>{{0}}</p>
          </div>
          <i class="el-icon-remove ys_icon"></i>
          </div>
        </div>
      </el-col>
      <el-row>
        <!-- <el-col :span="14">
          <div class="mg_10">  
          <div class="ys_chart">
            <div class="ys_chart_title">
              <span>
              数量统计</span>
            </div>
            <div class="ys_chart_box">
              <linechart :list="list"/>
            </div>
          </div>
          </div>
        </el-col> -->
        
        <!-- <el-col :span="12">
          <div class="mg_10">  
          <div class="ys_chart">
              <div class="ys_chart_title">
                <span>消防柜社区分布图示</span>
              </div>
            <div class="ys_chart_box">
              <piechart :charTitle="charTitle1" :charData="charData"/>
            </div>
          </div>
          </div>
        </el-col> -->
        <el-col :span="12">
          <div class="mg_10">  
          <div class="ys_chart">
              <div class="ys_chart_title">
                <span>消防柜器材分类管理图示</span>
              </div>
            <div class="ys_chart_box">
              <piechart :charTitle="charTitle2" :charData="charData"/>
            </div>
          </div>
          </div>
        </el-col>
      </el-row>
    </el-row>
  </div>
</template>

<script>
// import CHome from "./CHome";
// import MtHome from "./MtHome";
import linechart from "@/components/chart/linechart";
import timechart from "@/components/chart/timechart";
import piechart from "@/components/chart/piechart";
export default {
  name: "home",
  components: {
    // [CHome.name]: CHome,
    // [MtHome.name]: MtHome,
    linechart,
    timechart,
    piechart,
  },

  data() {
    return {
      loading: false,
      place_count:0,
      place_new_count:0,
      hidden_count:0,
      hidden_new_count:0,
      list:[],
      charTitle1: "社区分布图示",
      charTitle2: "器材分类图示",
      charData:{},
    };
  },

  mounted() {
    //   this.companyChart();
    //   this.taskCharg();
    //   this.userRoleChart();
    this.getList();
  },
  methods:{
    getList(){
      this.$_invoke(`home_getData`).then((res) => {
        res=res.data
        this.place_count=res.place_count
        this.place_new_count=res.place_new_count
        this.hidden_count=res.hidden_count
        this.hidden_new_count=res.hidden_new_count
        this.list=res.type_data;
        this.charData = [
                    {
                      value: 463,
                      name: "福田"
                    },
                    {
                      value: 395,
                      name: "岗厦"
                    },
                    {
                      value: 157,
                      name: "福安"
                    },
                    {
                      value: 149,
                      name: "福华"
                    },
                    {
                      value: 147,
                      name: "福民"
                    }
                  ]
      });
    }
  }
};
</script>
